import clsx from 'clsx'
import { getUnixTime } from 'date-fns'
import { Day, RowProps, useDayPicker } from 'react-day-picker'

/** Render a row in the calendar, with the days. */
export default function Row(props: RowProps) {
  const { components } = useDayPicker()

  const DayComponent = components?.Day ?? Day

  return (
    <tr>
      {props.dates.map((date) => (
        <td
          className={clsx('pt-2 text-center')}
          key={getUnixTime(date)}
          role="presentation"
        >
          <DayComponent displayMonth={props.displayMonth} date={date} />
        </td>
      ))}
    </tr>
  )
}
